import { useCallback, useEffect, useState } from 'react';

const storageKey = (caseid) => `projectUnfoldingCollapsedGroups:v1:${caseid}`;
const readCollapsedGroups = (caseid) => {
  if (caseid == null) return new Set();
  try {
    const ids = JSON.parse(localStorage.getItem(storageKey(caseid)) || '[]');
    return new Set(Array.isArray(ids) ? ids.slice(0, 5000).filter((id) => typeof id === 'string' && id.length <= 160) : []);
  } catch (error) {
    console.warn('Could not load collapsed action groups:', error);
    return new Set();
  }
};

export default function useCollapsedLogicalGroups(caseid) {
  const [state, setState] = useState(() => ({ caseid, ids: readCollapsedGroups(caseid) }));
  useEffect(() => setState({ caseid, ids: readCollapsedGroups(caseid) }), [caseid]);
  const toggle = useCallback((id) => {
    setState((current) => {
      const ids = new Set(current.caseid === caseid ? current.ids : readCollapsedGroups(caseid));
      if (ids.has(id)) ids.delete(id);
      else ids.add(id);
      if (caseid != null) {
        try { localStorage.setItem(storageKey(caseid), JSON.stringify([...ids])); }
        catch (error) { console.warn('Could not remember collapsed action groups:', error); }
      }
      return { caseid, ids };
    });
  }, [caseid]);
  return [state.caseid === caseid ? state.ids : new Set(), toggle];
}
